import { TemplatePage } from './types';

const live_streaming_fitness_theme: TemplatePage = {
  header: {
    color: '#E8B6B9',
    icon: 'images/video-templates/fitnes-wellness.jpg',
    title: 'Live Stream Templates — Fitness Theme',
    title_meta: 'Free Live Stream Overlay Templates — Fitness Theme',
    description_meta:
      `Get your live stream audience’s blood pumping with Wave.video's customizable fitness-themed templates.`,
    description:
      `Get your live stream audience’s blood pumping with these appealing customizable fitness-themed templates.` +
      ' Deliver a flawless live streaming experience for your viewers!'
  },
  footer: {
    category: 'Live Stream Fitness Theme',
    description:
      'With Wave.video’s trove of easy-to-edit themed templates, you can create memorable and engaging branded' +
      ' live streams with no effort. Leave a lasting impression on your audience with distinctive thumbnails,' +
      ' intros, outros, overlays, and lower thirds without the need to hire high-cost video editors. Take your' +
      ' next big step towards becoming a professional live streamer!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Fitness Theme',
      search: { name: 'FitnessTheme', tags: 'FitnessTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_fitness_theme;
